import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step2" }
const _hoisted_2 = { class: "donar-info" }
const _hoisted_3 = ["placeholder", "disabled"]
const _hoisted_4 = ["placeholder", "disabled"]
const _hoisted_5 = ["placeholder", "readonly", "disabled"]
const _hoisted_6 = ["placeholder", "disabled"]
const _hoisted_7 = ["placeholder", "disabled"]
const _hoisted_8 = {
  key: 0,
  class: "wpcm-checkbox-field"
}
const _hoisted_9 = {
  key: 1,
  class: "wpcm-checkbox-field wpcm-fee-recovery-field"
}
const _hoisted_10 = {
  key: 0,
  class: "wpcm-fee-recovery-breakdown"
}
const _hoisted_11 = {
  key: 2,
  class: "wpcm-checkbox-field wpcm-fee-recovery-field wpcm-fee-recovery-forced"
}
const _hoisted_12 = {
  key: 0,
  class: "wpcm-fee-recovery-breakdown"
}
const _hoisted_13 = {
  key: 3,
  class: "wpcm-test-card-info"
}
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Personal Info", -1 /* HOISTED */)),
      _createElementVNode("form", null, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('first_name'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.billing_fields.first_name) = $event)),
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_3), [
          [_vModelText, $setup.store.billing_fields.first_name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('last_name'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.store.billing_fields.last_name) = $event)),
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_4), [
          [_vModelText, $setup.store.billing_fields.last_name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: $setup.trans('email'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.billing_fields.email) = $event)),
          readonly: $props.is_logged_in && $props.email,
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_vModelText, $setup.store.billing_fields.email]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          placeholder: $setup.trans('phone'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.store.billing_fields.phone) = $event)),
          disabled: $setup.store.loading,
          onkeyup: "this.value=this.value.replace(/[^\\d]/,'')"
        }, null, 8 /* PROPS */, _hoisted_6), [
          [_vModelText, $setup.store.billing_fields.phone]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('address'),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.store.billing_fields.address) = $event)),
          disabled: $setup.store.loading
        }, null, 8 /* PROPS */, _hoisted_7), [
          [_vModelText, $setup.store.billing_fields.address]
        ]),
        ($props.show_anonymous_donation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_checkbox, {
                modelValue: $setup.store.billing_fields.anonymous_donation,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.store.billing_fields.anonymous_donation) = $event)),
                disabled: $setup.store.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.trans('anonymous_donation')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("v-if", true),
        ($props.show_fee_recovery && $props.fee_recovery_optin_mode === 'donor')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_checkbox, {
                modelValue: $setup.store.extras.fee_recovery_optin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.store.extras.fee_recovery_optin) = $event)),
                disabled: $setup.store.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.feeRecoveryMessage), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled"]),
              ($props.fee_recovery_show_breakdown && $setup.store.extras.fee_recovery_optin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.feeRecoveryBreakdown), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : ($props.show_fee_recovery && $props.fee_recovery_optin_mode === 'forced')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString($setup.feeRecoveryMessage), 1 /* TEXT */),
                ($props.fee_recovery_show_breakdown)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.feeRecoveryBreakdown), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
        ($props.enable_test_card_information && $setup.trans('test_card_information'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("p", {
                class: "wpcm-test-card-text",
                innerHTML: $setup.trans('test_card_information')
              }, null, 8 /* PROPS */, _hoisted_14)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}